import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_2 = { class: "gfu-grid__cell gfu-1of1 gfu-6of12--m" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_text_field = _resolveComponent("text-field")

  return (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_text_field, {
        modelValue: _ctx.email,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.email) = $event)),
        class: "_mt-0",
        name: "email",
        "display-name": "Email",
        "data-qa": "adyen-form:Email"
      }, null, 8 /* PROPS */, ["modelValue"])
    ])
  ]))
}